const uuid = (x: unknown): x is string => typeof x === 'string' && /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(x);
export type SupportTaskTarget = { projectId: string; taskId: string };
export function supportTaskTarget(projectId: unknown,taskId: unknown): SupportTaskTarget | null {
  return uuid(projectId) && uuid(taskId) ? {projectId,taskId} : null;
}
export function openSupportTask(data?: Record<string,unknown>): boolean {
  const target=supportTaskTarget(data?.project_id,data?.task_id);
  if (!target) return false;
  window.dispatchEvent(new CustomEvent('navigate-to-support-task',{detail:target}));
  return true;
}
